import { verifyResponseType } from '../VoPayApi.validation';
import { VoPayResponse } from '../VoPayApi.types';
import { type Http } from '../../../../services/http';
import type { AddressApi, DeleteAddressResponse } from './address.types';

export default function address(http: Http): AddressApi {
  return {
    address: {
      deleteAddress: async (params) => {
        const url = '/qa/client-account/address/delete';

        const { data } = await http.post<typeof params>({
          url,
          config: { params },
        });

        return verifyResponseType<DeleteAddressResponse>(url, data, [VoPayResponse.ApiResponse]);
      },
    },
  };
}
